import { getStyles } from './SuggestionsHeaderFooterInfo.styles';
import { ITheme } from '@uifabric/styling';
import { classNamesFunction } from '@uifabric/utilities';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { ControlIcons } from 'owa-control-icons';
import { getExtendedTheme } from 'owa-fabric-theme';
import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
import {
    SuggestionsHeaderFooterInfoProps,
    SuggestionsHeaderFooterInfoStyles,
    SuggestionsHeaderFooterInfoStyleProps,
} from './SuggestionsHeaderFooterInfo.types';
import saveLinkedInBindingDismissed from '../actions/saveLinkedInBindingDismissed';
import { FloatingPeoplePicker } from 'office-ui-fabric-react/lib/FloatingPicker';

const getClassNames = classNamesFunction<
    SuggestionsHeaderFooterInfoStyleProps,
    SuggestionsHeaderFooterInfoStyles
>();

let classNamesUtil = require('classnames');

const SuggestionsHeaderFooterInfo = (props: SuggestionsHeaderFooterInfoProps) => {
    let {
        infoType,
        queryString,
        picker,
        numberOfResults,
        theme = getExtendedTheme() as ITheme,
    } = props;
    const classNames = getClassNames(getStyles, { theme: theme });
    switch (infoType) {
        case FindRecipientInfoType.SuggestedContacts:
            return (
                <div
                    className={classNamesUtil(
                        classNames.textContainer,
                        classNames.suggestedContactsHeaderBox
                    )}>
                    <span className={classNames.suggestedContactsText}>
                        {strings.findRecipientResult_SuggestedContactsHeader}
                    </span>
                </div>
            );
        case FindRecipientInfoType.Searching:
            return (
                <div className={classNamesUtil(classNames.footerBorder, classNames.container)}>
                    <div className={classNames.iconContainer}>
                        <Spinner theme={theme} />
                    </div>
                    <div className={classNames.textContainer}>
                        {format(strings.findRecipientInfo_Searching, queryString)}
                    </div>
                </div>
            );
        case FindRecipientInfoType.TypeToSearch:
            return (
                <div className={classNames.container}>
                    <div className={classNamesUtil(classNames.textContainer, classNames.centered)}>
                        {strings.findRecipientInfo_TypeToSearch}
                    </div>
                </div>
            );
        case FindRecipientInfoType.SearchDirectory:
            return (
                <div className={classNamesUtil(classNames.footerBorder, classNames.container)}>
                    <div className={classNames.iconContainer}>
                        <Icon className={classNames.searchIcon} iconName={ControlIcons.Search} />
                    </div>
                    <div className={classNames.textContainer}>
                        {isConsumer()
                            ? strings.findRecipientInfo_SearchPeople
                            : strings.findRecipientInfo_SearchDirectory}
                    </div>
                </div>
            );
        case FindRecipientInfoType.TopNResults:
            return (
                <div className={classNamesUtil(classNames.footerBorder, classNames.container)}>
                    <div className={classNamesUtil(classNames.textContainer, classNames.centered)}>
                        {numberOfResults
                            ? format(strings.findRecipientInfo_TopNResults, numberOfResults)
                            : strings.findRecipientInfo_NoResultsFound}
                    </div>
                </div>
            );
        case FindRecipientInfoType.UseAddress:
            return (
                <div
                    className={classNamesUtil(
                        classNames.headerBorder,
                        classNames.textContainer,
                        classNames.useAddressContainer
                    )}>
                    {format(strings.findRecipientInfo_UseThisAddress, queryString)}
                </div>
            );
        case FindRecipientInfoType.FindPeopleFeedback:
            return (
                <div
                    className={classNamesUtil(
                        classNames.footerBorder,
                        classNames.textContainer,
                        classNames.feedbackContainer
                    )}>
                    <Icon className={classNames.feedbackInfoIcon} iconName={ControlIcons.Info} />
                    {strings.peopleFeedbackSubmitSearchFeedback}
                </div>
            );
        case FindRecipientInfoType.LinkedInAccountBind:
            return (
                <div
                    className={classNamesUtil(
                        classNames.footerBorder,
                        classNames.linkedInBindContainer,
                        classNames.container
                    )}>
                    <Icon
                        className={classNamesUtil(
                            classNames.linkedInIcon,
                            classNames.verticalCenter
                        )}
                        iconName={ControlIcons.LinkedInLogo}
                    />
                    <span
                        className={classNamesUtil(
                            classNames.linkedInBindText,
                            classNames.verticalCenter
                        )}>
                        {strings.LinkedInBindingButtonText}
                    </span>
                    <div
                        className={classNames.linkedinBindingDismiss}
                        onClick={onLinkedInBindingDismiss(picker)}>
                        <Icon className={classNames.cancelIcon} iconName={ControlIcons.Cancel} />
                    </div>
                </div>
            );
        default:
            return null;
    }
};

const onLinkedInBindingDismiss = (picker: FloatingPeoplePicker) => {
    return function(ev: React.MouseEvent<EventTarget>): void {
        ev.stopPropagation();
        saveLinkedInBindingDismissed(picker);
    };
};

export default SuggestionsHeaderFooterInfo;
